import globalMU from "../../../globalMU";
import React, { useState } from "react";
import { Paginacao } from "../itens-orcamento/paginacao/Paginacao";
import { RespostaListarHistoricoLimiteCredito } from "app/types/cliente/RespostaLimiteCredito";
const estiloLimiteCredito = require("./limite-credito.module.scss").default;

export type LimiteCreditoProps = {
  cpfCnpj: string;
  nome: string;
  limiteAtual: number;
  tipoLimiteAtual: string;
  dadosLimiteCredito: RespostaListarHistoricoLimiteCredito;
  onAlterarListaSelecionada: (numeroPagina: number) => void;
  onHistorico: () => void;
};

export const LimiteCredito = (props: LimiteCreditoProps) => {
  const [mostrarGrid, setMostrarGrid] = useState(false);
 
  return (
    <div>
      <div className={estiloLimiteCredito.form}>
        <label>CPF/CNPJ</label>
        <div>{props.cpfCnpj}</div>
        <label>Nome</label>
        <div>{props.nome}</div>
      </div>
      <br />
      <div className={estiloLimiteCredito.form}>
        <label>Limite Atual</label>
        <div>{globalMU.formatarValorNumerico(props.limiteAtual, 2)}</div>
        <label>Tipo de Limite Atual</label>
        <div>{props.tipoLimiteAtual}</div>
      </div>
      <div className={estiloLimiteCredito.separador}></div>
      <button
        type="button"
        className={`no-global-button ${estiloLimiteCredito.buttonLimiteCredito}`}
        onClick={() => {
          setMostrarGrid(true);
          props.onHistorico();
        }}
      >
        Histórico
      </button>

      {mostrarGrid && props.dadosLimiteCredito?.Entities?.length > 0 && (
        <div className={estiloLimiteCredito.barraRolagem}>
          <table
            className={`_table _w-full _border-collapse ${estiloLimiteCredito.tabelaLimiteCredito}`}
          >
            <thead className="_table-header-group">
              <tr className="_table-row">
                <th
                  className={`_table-cell ${estiloLimiteCredito.tableCellHeader}`}
                >
                  Data/Hora
                </th>
                <th
                  className={`_table-cell ${estiloLimiteCredito.tableCellHeader}`}
                >
                  Valor
                </th>
                <th
                  className={`_table-cell ${estiloLimiteCredito.tableCellHeader}`}
                >
                  Limite mensal
                </th>
                <th
                  className={`_table-cell ${estiloLimiteCredito.tableCellHeader}`}
                >
                  Tipo
                </th>
                <th
                  className={`_table-cell ${estiloLimiteCredito.tableCellHeader}`}
                >
                  Usuário
                </th>
                <th
                  className={`_table-cell ${estiloLimiteCredito.tableCellHeader}`}
                >
                  Liberação
                </th>
                <th
                  className={`_table-cell ${estiloLimiteCredito.tableCellHeader}`}
                >
                  Observação
                </th>
              </tr>
            </thead>
            <tbody className="_table-row-group">
              {props.dadosLimiteCredito?.Entities?.map((value) => (
                <tr key={value.Data} className={`_table-row ${estiloLimiteCredito.linha}`}>
                  <td
                    className={`_table-cell ${estiloLimiteCredito.tableCellBody}`}
                    style={{ textAlign: "right" }}
                  >
                    {globalMU.formatDateTime(value.Data)}
                  </td>
                  <td
                    className={`_table-cell ${estiloLimiteCredito.tableCellBody}`}
                    style={{ textAlign: "right" }}
                  >
                    {globalMU.formatarValorNumerico(value.Limite, 2)}
                  </td>
                  <td
                    className={`_table-cell ${estiloLimiteCredito.tableCellBody}`}
                    style={{ textAlign: "right" }}
                  >
                    {globalMU.formatarValorNumerico(value.LimiteMensal, 2)}
                  </td>
                  <td
                    className={`_table-cell ${estiloLimiteCredito.tableCellBody}`}
                  >
                    {value.DescricaoTipo}
                  </td>
                  <td
                    className={`_table-cell ${estiloLimiteCredito.tableCellBody}`}
                  >
                    {value.Usuario}
                  </td>
                  <td
                    className={`_table-cell ${estiloLimiteCredito.tableCellBody}`}
                  >
                    {value.CodigoLiberacao && value.CodigoLiberacao!=null ? `${value?.CodigoLiberacao} - ${value?.SenhaLiberacao} ` : ""}
                  </td>
                  <td
                    className={`_table-cell ${estiloLimiteCredito.tableCellBody}`}
                  >
                    {value?.Observacao}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {props.dadosLimiteCredito.PageCount > 1 && (
            <div style={{ marginTop: "0.5em" }}>
              <Paginacao
                paginaAtual={props.dadosLimiteCredito.ActualPage}
                totalPaginas={props.dadosLimiteCredito.PageCount}
                id="LimiteCredito_Paginacao"
                onAlterarListaSelecionada={props.onAlterarListaSelecionada}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
